import {
  getInt32,
  getOptionalInt32,
} from "@surya-digital/leo-ts-types";

export interface SampleBreakdownDTO {
  sample: number;
  skipped: number;
  total?: number | null;
}

export class SampleBreakdown {
  readonly isSampleBreakdownSampleBreakdown: boolean = true;

  readonly sample: number;
  readonly skipped: number;
  readonly total: number | null;

  static readonly constraints = {
    "sample": {
      "minValue": 0,
    },
    "skipped": {
      "minValue": 0,
    },
    "total": {
      "minValue": 0,
    }
  }

  constructor(
  sample: number, 
  skipped: number, 
  total: number | null = null
  ) {
    SampleBreakdown.validateSample(sample);
    this.sample = sample;
    SampleBreakdown.validateSkipped(skipped);
    this.skipped = skipped;
    if ( total !== undefined && total !== null) {
      SampleBreakdown.validateTotal(total);
    }
    this.total = total;
  }

  static fromDTO(dto: SampleBreakdownDTO): SampleBreakdown {
    const sample = getInt32(dto, "sample", InvalidSampleBreakdownSampleError);
    const skipped = getInt32(dto, "skipped", InvalidSampleBreakdownSkippedError);
    const total = getOptionalInt32(dto, "total", InvalidSampleBreakdownTotalError);
    return new SampleBreakdown(
      sample,
      skipped,
      total
    );
  }

  toDTO(): SampleBreakdownDTO {
    const dto: SampleBreakdownDTO = {
        sample: this.sample,
        skipped: this.skipped,
    };
    if (this.total !== undefined && this.total !== null){
      dto.total = this.total;
    }
    return dto;
  }
  private static validateSample = (sample: number): void => {
    if(sample < 0) {
      throw new InvalidSampleBreakdownSampleMinValueError(
        0,
        `Attribute sample has value ${sample}. Min value is 0.`
      );
    }
  }
  private static validateSkipped = (skipped: number): void => {
    if(skipped < 0) {
      throw new InvalidSampleBreakdownSkippedMinValueError(
        0,
        `Attribute skipped has value ${skipped}. Min value is 0.`
      );
    }
  }
  private static validateTotal = (total: number): void => {
    if(total < 0) {
      throw new InvalidSampleBreakdownTotalMinValueError(
        0,
        `Attribute total has value ${total}. Min value is 0.`
      );
    }
  }
  
}

SampleBreakdown.prototype.toString = function toString(): string {
  return `SampleBreakdown(sample='${this.sample}',skipped='${this.skipped}',total='${this.total}')`;
};

export class InvalidSampleBreakdownError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSampleBreakdownError";
  }
}
export class InvalidSampleBreakdownSampleError extends InvalidSampleBreakdownError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSampleBreakdownSampleError";
  }
}

export class InvalidSampleBreakdownSampleMinValueError extends InvalidSampleBreakdownSampleError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSampleBreakdownSampleMinValueError";
  }
}

export class InvalidSampleBreakdownSkippedError extends InvalidSampleBreakdownError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSampleBreakdownSkippedError";
  }
}

export class InvalidSampleBreakdownSkippedMinValueError extends InvalidSampleBreakdownSkippedError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSampleBreakdownSkippedMinValueError";
  }
}

export class InvalidSampleBreakdownTotalError extends InvalidSampleBreakdownError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSampleBreakdownTotalError";
  }
}

export class InvalidSampleBreakdownTotalMinValueError extends InvalidSampleBreakdownTotalError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSampleBreakdownTotalMinValueError";
  }
}
